import React, { useEffect, useState } from "react";
import arrowIcon from "../../../../assets/arrow-down.svg";
import Button from "../../../Button/Button";

const slugify = (str) => typeof str === 'string'
  ? str
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, "")
    .replace(/[\s_-]+/g, "-")
    .replace(/^-+|-+$/g, "") 
  : '';

const getHeadlines = (frequentQuestionsContainer) =>{
  const headlines: any[] = [];
  const el = document.getElementsByClassName(frequentQuestionsContainer)[0];

  if(el){
    const headlinesElements = el.getElementsByTagName('h3');
    for (var i = 0; i < headlinesElements.length; i++) {
      const headlineEl = headlinesElements[i];
      const title = headlineEl.innerText;
      const id = slugify(title);
      headlines.push({ id, title })

      headlineEl.id = id
    }
  }

  return headlines
}

const LegalFirstStep: React.FC<any> = ({ headline, description, frequentQuestionsContainer, isSave }) => {
  const dangerouslySetInnerHTML =
    typeof description === "string" ? { __html: description } : undefined;
  const headlines: any[] = getHeadlines(frequentQuestionsContainer);
    
  return (
    <div>
      <div className="gatewayFormWrapper container">
        <div>
          <h2 className="title-form">{headline}</h2>
          <div
            className="description-form"
            dangerouslySetInnerHTML={dangerouslySetInnerHTML}
          >
            {typeof description !== "string" ? description : null}
          </div>
        </div>
        <div className="container-button">
          <Button
            variant={"secondary"}
            onClick={() => window.toggleGatewayForm("legal-step-two")}
            text="Check if you're eligible"
          />
          <div className="pt-2"></div>
          <Button
            variant={"secondary"}
            onClick={() => window.location.href = "https://forms.office.com/Pages/ResponsePage.aspx?id=iJmhWGKz8UqJorI81ZL02GBFocfe8QZPvjDOj8q9JWVUNVNXQlZMUURYU1VXSTkzSEZBQjFBRFpPRSQlQCN0PWcu"}
            text="Report a police interaction"
          />
        </div>
        <div className="container-list">
          <h4 className="secondary-title">On this page: </h4>
          <ul>
            {headlines.map((headline: any, index: number) => (
              <li>
                <img src={arrowIcon} className="icon" alt="arrow icon" />
                <a href={`#${headline.id}`}>{headline.title}</a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
export default LegalFirstStep;
